import { useState, useEffect, useRef } from 'react';
import { ApiGet } from '../Api';
import TopBar from '../TopBar';
import { titleColor, backgroundMainColor, backgroundSubColor } from '../Color';
import Grid from '../Grid';
import PaginationGrid from '../../src/PaginationGrid';
import { ReactComponent as Search } from "../Image/search.svg";

const MainFunction = function ProductionHistory({ ChangeMonitoring, setInquiryFunction }) { 
  const gridGap = 30;
  const gridPadding = 30;
  const topBarHeight = 60;
  const gridItemStyle = {
    backgroundColor: backgroundMainColor,
    borderRadius: '10px',
    height: '100%'
  };

  const [gridStyle, setGridStyle] = useState(GetGridStyle());

  useEffect(() => {
    document.title = 'LINE RECYCLE MONITORING';

    let intervalId;

    Inquiry();
     if (ChangeMonitoring === undefined) {
      intervalId = setInterval(() => {
        Inquiry();
      }, 1000 * 60);
    } /*else {
      setInquiryFunction(() => ChangeMonitoring);
    }*/

    async function Resize() {
      setPaginationContent(<></>);
      Inquiry();
    }

    window.addEventListener('resize', Resize);

    return () => {
      window.removeEventListener('resize', Resize);
      
      if (intervalId) {
        clearInterval(intervalId);
      }

      setGridStyle(null);
    };
  }, []);

  const [gridData, setGridData] = useState([
    { batch_number: '135', production_amount: '268.0', G1: '53216', G2: '15477', G3: '79117', G4: '0', G5: '0', F: '3140.5', D: '1959.9', AP: '8485.8', AD: '267.9', RC: '96078', SMA: '0.0' },
  ]);
  async function Inquiry() {
    const response = await ApiGet(`${process.env.REACT_APP_API_DOMAIN}line-recycle/production-history/total?startDate=${dateRef.current.start}&endDate=${dateRef.current.end}`);
    if (response !== null && response.ok) {
      const json = await response.json();
      setGridData(json);
      setPaginationContent(
        <div style={gridItemStyle}>
          <div style={{ color: titleColor, fontSize: 30, fontWeight: 'bold', display: 'flex', justifyContent: 'start', alignItems: 'center', height: 40 }}>
            상세내역
          </div>
          <div style={{ height: `calc(100% - 40px)` }}>
            <PaginationGrid mainHeight={0} inquiryCondition={true} apiUrl={`${process.env.REACT_APP_API_DOMAIN}line-recycle/production-history/detail?startDate=${dateRef.current.start}&endDate=${dateRef.current.end}&`}/>          
          </div>
        </div>
      );
    }
  }

  function GetGridStyle() {
    return {
      display: 'grid',
      gap: gridGap,
      padding: gridPadding,
      backgroundColor: backgroundMainColor,
      width: '100vw',
      height: `calc(100vh - ${topBarHeight}px)`,
      boxSizing: 'border-box', //패딩을 포함하여 크기 계산
      overflow: 'auto',
      scrollbarWidth: 'none',
      gridTemplateRows: '40px 160px 1fr'
    };
  }

  const columnDictionary = {
    'ton_amount': { label: '생산량 (t)' },
    'G1': { label: 'G1 (kg)' },
    'G2': { label: 'G2 (kg)' },
    'G3': { label: 'G3 (kg)' },
    'G4': { label: 'G4 (kg)' },
    'G5': { label: 'G5 (kg)' },
    'F': { label: 'F (kg)' },
    'D': { label: 'D (kg)' },
    'AP': { label: 'AP (kg)' },
    'AD': { label: 'AD (kg)' },
    'RC': { label: 'RC (kg)' },
    'SMA': { label: 'SMA (kg)' },
    'total': { label: 'Total (kg)' }
  };

  const logoContent = <span style={{ color: titleColor, fontSize: 40, fontWeight: 'bold' }}>라인리사이클</span>;

  const [date, setDate] = useState({ start: GetDateTime(), end: GetDateTime() });
  const dateRef = useRef(date);
  useEffect(() => {
    dateRef.current = date;
  }, [date]);

  function GetDateTime() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); //월은 0부터 시작하므로 +1
    const day = String(now.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  const [paginationContent, setPaginationContent] = useState(<></>);

  return (
    <div onContextMenu={(event)=>{ event.preventDefault(); }} style={{ userSelect: 'none', width: '100vw', height: '100vh', backgroundColor: backgroundMainColor }}>
      <TopBar logo={logoContent} title={'생산 이력 조회'} ChangeMonitoring={ChangeMonitoring} />

      <div style={gridStyle}>
        <div style={{ backgroundColor: backgroundMainColor, height: 40, display: 'flex', flexDirection: 'row', gap: 30, justifyContent: 'end' }}>
          <label style={{ height: '100%', color: titleColor, fontSize: 20, fontWeight: 'bold', display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
            시작
            <input 
              type='date'
              style={{ height: '100%', backgroundColor: backgroundSubColor, color: titleColor, fontSize: 20, fontWeight: 'bold', colorScheme: 'dark', marginLeft: 10, borderRadius: 10, border: 'none', paddingLeft: 10, paddingRight: 10 }}
              value={date.start}
              onClick={(e)=>e.currentTarget.showPicker()}
              onChange={(e) => {
                setDate({ ...date, start: e.target.value });
              }}
            />
          </label>

          <label style={{ height: '100%', color: titleColor, fontSize: 20, fontWeight: 'bold', display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
            종료
            <input 
              type='date'
              style={{ height: '100%', backgroundColor: backgroundSubColor, color: titleColor, fontSize: 20, fontWeight: 'bold', colorScheme: 'dark', marginLeft: 10, borderRadius: 10, border: 'none', paddingLeft: 10, paddingRight: 10 }}
              value={date.end}
              onClick={(e)=>e.currentTarget.showPicker()}
              onChange={(e) => {
                setDate({ ...date, end: e.target.value });
              }}
            />
          </label>

          <div  onClick={() => Inquiry()}>
            <Search title='검색' width='23' height='23' fill='rgb(204,204,204)' style={{ position: 'relative', top: 8, cursor: 'pointer', marginRight: 20 }} />
          </div>
        </div>

        <div style={gridItemStyle}>
          <div style={{ color: titleColor, fontSize: 30, fontWeight: 'bold', display: 'flex', justifyContent: 'start', alignItems: 'center', height: 40 }}>
            Total
          </div>
          <div style={{ height: `calc(100% - 40px)` }}>
            <Grid cellData={gridData} columnDictionary={columnDictionary} inquiryInterval={60} />
          </div>
        </div>

        {paginationContent}
      </div>
    </div>
  );
}

export default MainFunction;